// extracted by mini-css-extract-plugin
export default {"productGallery":"EH-z","infoAboveGallery":"FH-z","inQuickShop":"GH-z"};